import { useDatabase } from "@nozbe/watermelondb/hooks";
import React from "react";
import {
  FlatActionList,
  FlatActionListItem,
  Page,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { useFormContext } from "react-hook-form";
import { Feather } from "@expo/vector-icons";
import { StackScreenProps } from "@react-navigation/stack";
import { useTranslation } from "../../utilities/i18n";
import RetailerPayType from "../../utilities/data/model/RetailerPayType";

export type SelectRetailerPayTypeModalScreenProps = StackScreenProps<
  any,
  "SelectRetailerPayTypeModalScreen"
>;

export const SelectRetailerPayTypeModalScreen = ({
  navigation,
}: SelectRetailerPayTypeModalScreenProps) => {
  const { t } = useTranslation("common");
  const database = useDatabase();

  const [retailerPayTypes, setPayTypes] = React.useState<
    RetailerPayType[] | undefined
  >();

  const { watch, setValue } = useFormContext<{
    retailerPayTypeId: string;
  }>();

  const { colors } = useThemeProvider();

  const watchedPayTypeId = watch("retailerPayTypeId");

  React.useEffect(() => {
    database
      .get<RetailerPayType>("retailer_pay_types")
      .query()
      .fetch()
      .then((l) => setPayTypes(l));
  }, []);

  const handleOnSelect = React.useCallback((retailerPayTypeId: string) => {
    setValue("retailerPayTypeId", retailerPayTypeId, {
      shouldValidate: true,
      shouldDirty: true,
    });
    navigation.goBack();
  }, []);

  const items: FlatActionListItem[] = React.useMemo(() => {
    return (
      retailerPayTypes?.map((payTypes) => {
        return {
          key: payTypes.id,
          title: payTypes.payDescription ?? "Unknown paytype",
          subTitle: `Paycode: ${payTypes.payCode}`,
          onPress: () => handleOnSelect(payTypes.id),
          componentRight: (icon) => {
            return watchedPayTypeId == payTypes.id ? (
              <Feather name="check" size={24} color={colors.primary} />
            ) : (
              icon
            );
          },
        };
      }) || []
    );
  }, [retailerPayTypes, watchedPayTypeId, handleOnSelect]);

  return (
    <Page title={t("modal_select_paytype_title")}>
      <FlatActionList items={items} />
    </Page>
  );
};
